import { render, staticRenderFns } from "./detailTable.vue?vue&type=template&id=7c235a64&scoped=true"
import script from "./detailTable.vue?vue&type=script&lang=js"
export * from "./detailTable.vue?vue&type=script&lang=js"
import style0 from "./detailTable.vue?vue&type=style&index=0&id=7c235a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c235a64",
  null
  
)

export default component.exports